export const LIST_EXPORT_TRANSACTION_REQUEST = 'LIST_EXPORT_TRANSACTION_REQUEST'
export const LIST_EXPORT_TRANSACTION_SUCCESS = 'LIST_EXPORT_TRANSACTION_SUCCESS'
export const LIST_EXPORT_TRANSACTION_FAIL = 'LIST_EXPORT_TRANSACTION_FAIL'

export const DOWNLOAD_EXPORT_TRANSACTION_REQUEST = 'DOWNLOAD_EXPORT_TRANSACTION_REQUEST'
export const DOWNLOAD_EXPORT_TRANSACTION_SUCCESS = 'DOWNLOAD_EXPORT_TRANSACTION_SUCCESS'
export const DOWNLOAD_EXPORT_TRANSACTION_FAIL = 'DOWNLOAD_EXPORT_TRANSACTION_FAIL'

export const EXPORT_EXPORT_TRANSACTION_REQUEST = 'EXPORT_EXPORT_TRANSACTION_REQUEST'
export const EXPORT_EXPORT_TRANSACTION_SUCCESS = 'EXPORT_EXPORT_TRANSACTION_SUCCESS'
export const EXPORT_EXPORT_TRANSACTION_FAIL = 'EXPORT_EXPORT_TRANSACTION_FAIL'
